import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actions } from './sagaSlice';
import { Loader, Dimmer } from 'semantic-ui-react';

const UnitView = props => {

    const { readOne, unit, isFetching } = props;
    const { id } = useParams();

    useEffect(() => {
        readOne({ unitId: id });
    }, [id, readOne]);

    if (!unit || isFetching) {
        return <Dimmer page active>
            <Loader />
        </Dimmer>;
    }

    return <div>{unit.name}</div>;
};

const mapStateToProps = (state, ownProps) => ({
    unit: state.units.data[ownProps.match.params.id],
    isFetching: state.units.isFetching
});

export default connect(mapStateToProps, actions)(UnitView);

